import styled from 'styled-components';

import { theme } from '../../../global-styles/colors';
import { AlxSelectStyle } from '../../../components/alx-components/select';

export const OnboardingStyle = styled.div`
  min-height: calc(100vh - 212px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .onboarding-top {
    margin-bottom: 32px;
  }

  .onboarding-nav {
    display: flex;
    justify-content: flex-end;
    width: 120px;

    p {
      cursor: pointer;
      color: ${theme.status.error.medium};
      font-weight: 500;
      font-size: 18px;
    }
  }
  ${AlxSelectStyle} {
    .MuiSelect-iconFilled {
      top: 16px;
    }
  }
`;
